import {fetchUtils} from 'react-admin';
import {stringify} from "query-string";
import moment from "moment";

const fetchJson = (url, options = {}) => {
    const api = localStorage.getItem('timeAttendanceApi')
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    let query = ''
    if(options.query)
    {
        query = "?" + stringify(options.query)
    }
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    options.headers.set('Authorization', localStorage.getItem('tik_api_key'));
    if (options.body) {
        options.headers.set('Content-Type', 'application/json');
    }

    return fetch(api + url + query, options)
        .then(response => {
            if (response.status === 401) {
                throw { status: 401, message: 'Time Attendance API: Authentication failed. Please check your API key in company settings.' };
            }
            if (response.status >= 400) {
                return response.json().then(data => {
                    throw { status: response.status, message: data.message || 'Request failed' };
                });
            }
            return response.json();
        })
        .then(json => ({ json }))
        .catch(e => {
            throw e;
        });

}



export function getMonthlyAttendanceHours({month, year,fillRest,maxHours}) {
   return fetchJson('/hours', {
    query:{
        month, year, fillRest, maxHours
    }
}).then(_a => {
       let json =_a.json;
       return {data:json}
   })
}

export function getMonthlyTimeSheet({startDate,endDate, month, year, currentTeam}) {
    return fetchJson('/timeSheets', {
        query:{
            startDate:moment(startDate).format("YYYY-MM-DD"), endDate:moment(endDate).format("YYYY-MM-DD"), month, year, currentTeam
        }
    }).then(_a => {
        let json =_a.json;
        return {data:json}
    })
}

export function getAbsentDaysFromOffencePenality({startDate,endDate}) {
    return fetchJson('/offencesForPayroll', {
        query:{
            startDate:moment(startDate).format("YYYY-MM-DD"), endDate:moment(endDate).format("YYYY-MM-DD")
        }
    }).then(_a => {
        let json =_a.json;
        return {data:json}
    })
}

export function getTerminations({status}) {
    return fetchJson('/terminations', {
        query:{
            status
        }
    }).then(_a => {
        let json =_a.json;
        return {data:json}
    })
}

export function updateTermination({id,termination}) {
    return fetchJson('/updateTermination', {
        method: 'POST',
        body: JSON.stringify({id, termination}),
    }).then(_a => {
        let json =_a.json;
        return {data:json}
    })
}

export function getNewHires({status}) {
    return fetchJson('/newHires', {
        query:{
            status
        }
    }).then(_a => {
        let json =_a.json;
        return {data:json}
    })
}

export function getTeams() {
    return fetchJson('/teams', {

    }).then(_a => {
        let json =_a.json;
        return {data:json}
    })
}

export function updateNewHires({id,newHire}) {
    return fetchJson('/updateNewHires', {
        method: 'POST',
        body: JSON.stringify({id, newHire}),
    }).then(_a => {
        let json =_a.json;
        return {data:json}
    })
}
